import {
  SIA_ENTERPRISE_NOMINATIONS_URL,
  SIA_INDIVIDUAL_NOMINATIONS_URL,
} from "@util/constant";

/**
 * component to render in nominations tab at How to Nominate page
 */
const NominationsSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-50 px-5 py-4 font-public-sans">
      <p>
        Download the application form for Individual category
        <a
          href={SIA_INDIVIDUAL_NOMINATIONS_URL}
          target="_blank"
          className="text-blue-175"
          rel="noreferrer"
        >
          {" here."}
        </a>
      </p>
      <p>
        Download the application form for Enterprise categories{" "}
        <a
          href={SIA_ENTERPRISE_NOMINATIONS_URL}
          target="_blank"
          className="text-blue-175"
          rel="noreferrer"
        >
          {" here."}
        </a>
      </p>
      <p></p>
      <p>
        Please email the application package including the completed application
        form in PDF format and relevant supporting materials that highlight
        necessary information to jasmineng@sph.com.sg by 29 May 2026. Thank you.
      </p>
    </div>
  );
};

export default NominationsSection;
